// extracted by mini-css-extract-plugin
export var askAiIcon = "_q7-9";
export var container = "_q7-0";
export var groupSeparator = "_q7-a";
export var highlight = "_q7-4";
export var resultIcon = "_q7-5";
export var resultItem = "_q7-7";
export var resultSubtitle = "_q7-3";
export var resultTitle = "_q7-2";
export var resultsList = "_q7-1";
export var searchGroup = "_q7-6";
export var selected = "_q7-8";